import dayjs from "dayjs";

export const formatDateDayMonthYear = (date: any) => {
  return dayjs(date).format("DD/MM/YYYY");
};

export const formatTimeHoursMinute = (date: any) => {
  return dayjs(date).format("HH:mm");
};

export const getLocalTimeString = (time: number) => {
  const now = new Date();
  now.setUTCHours(time / 60, time % 60, 0, 0);

  return now.toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const minutesToTime = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
    .toString()
    .padStart(2, "0");
  const mins = (minutes % 60).toString().padStart(2, "0");
  return `${hours}:${mins}`;
};
export const timeToMinutes = (time: string) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

export const getLocalTimeStringtoNumber = (time: number) => {
  const now = new Date();
  now.setUTCHours(time / 60, time % 60, 0, 0);

  const temp = now.toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const [hours, minutes] = temp.split(":").map(Number);
  return hours * 60 + minutes;
};
